import * as React from 'react';
import { Box } from '@lumahealthhq/ui-core';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @ignore - internal component.
 */
function EmptyContent({
  children
}) {
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      position: 'absolute',
      pointerEvents: 'none',
      paddingTop: 'calc(64px + 57px - 52px)',
      //  Label height + TableHeader height - TableFooter
      inset: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      '& > *': {
        pointerEvents: 'auto'
      }
    },
    children: children
  });
}
export default EmptyContent;